import HttpClient from './HttpClient'

export async function fetchSheetReview(slug) {
  const { data } = await HttpClient().get(`/api/v1/characters/${slug}/sheet-review`)
  return data?.data ?? data
}

export async function resubmitSheetReview(slug) {
  const { data } = await HttpClient().post(`/api/v1/characters/${slug}/sheet-review/resubmit`)
  return data?.data ?? data
}

export async function updateSheetReviewFields(slug, fields) {
  const { data } = await HttpClient().put(`/api/v1/characters/${slug}/sheet-review/fields`, { fields })
  return data?.data ?? data
}

export async function fetchSheetReviewQueue(status = 'in_review') {
  const { data } = await HttpClient().get('/api/v1/admin/sheet-review/queue', {
    params: { status },
  })
  return data?.data ?? data ?? []
}

export async function fetchSheetReviewDetail(characterId) {
  const { data } = await HttpClient().get(`/api/v1/admin/sheet-review/${characterId}`)
  return data?.data ?? data
}

export async function decideSheetField(characterId, fieldKey, { status, comment }) {
  const { data } = await HttpClient().post(
    `/api/v1/admin/sheet-review/${characterId}/fields/${encodeURIComponent(fieldKey)}`,
    { status, comment }
  )
  return data?.data ?? data
}

export async function approveGeninSkip(characterId) {
  const { data } = await HttpClient().post(
    `/api/v1/admin/sheet-review/${characterId}/genin-skip/approve`
  )
  return data?.data ?? data
}

export async function rejectGeninSkip(characterId) {
  const { data } = await HttpClient().post(
    `/api/v1/admin/sheet-review/${characterId}/genin-skip/reject`
  )
  return data?.data ?? data
}

const STATUS_LABELS = {
  draft: 'Borrador',
  in_review: 'En revisión',
  needs_correction: 'Correcciones pendientes',
  approved: 'Aprobada (sellada)',
}

const FIELD_STATUS_LABELS = {
  pending: 'Pendiente',
  accepted: 'Aceptada',
  needs_change: 'Requiere cambio',
}

const SKIP_STATUS_LABELS = {
  pending: 'Skip Shinobi pendiente',
  approved: 'Skip Shinobi aprobado',
  rejected: 'Enviado a academia',
}

export function sheetStatusLabel(status) {
  return STATUS_LABELS[status] || status || '—'
}

export function fieldStatusLabel(status) {
  return FIELD_STATUS_LABELS[status] || status || '—'
}

export function geninSkipStatusLabel(status) {
  if (!status) return null
  return SKIP_STATUS_LABELS[status] || status
}

export const FIELD_LABELS = {
  name: 'Nombre',
  clan: 'Clan',
  age: 'Edad',
  gender: 'Género',
  dominantHand: 'Mano dominante',
  bloodType: 'Grupo sanguíneo',
  element: 'Elemento',
  birthHanSlug: 'Han de nacimiento',
  rank: 'Rango',
  stats: 'Atributos',
  descPhysical: 'Descripción física',
  descPsychological: 'Descripción psicológica',
  history: 'Historia',
}
